export const getUserLanguage = () => typeof window !== 'undefined' && window.location.pathname.split('/')[1] || 'en';